import { api, nullOn404 } from 'shared/api/client';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CoverageResponse } from './coverage-types';

export const coverageQueryKeys = {
  coverageByDocument: 'COVERAGE_BY_DOCUMENT',
} as const;

export function useCoverage(documentSuperId: number | string | undefined, enabled: boolean): UseQueryResult<CoverageResponse | null> {
  return useQuery({
    queryKey: [coverageQueryKeys.coverageByDocument, documentSuperId],

    queryFn: () =>
      api
        .GET('/coverage/document/{documentSuperId}', { params: { path: { documentSuperId: String(documentSuperId) } } })
        .then((res) => res.data)
        .catch(nullOn404),

    enabled: enabled && documentSuperId !== undefined,
    staleTime: 0,
  });
}
